import React from 'react';
import IframePage from './IframePage';

export default function OrganigrammePage() {
  return (
    <IframePage
      title="Organigramme"
      url="https://orga.ecotechsystem.ca"
    />
  );
}
